import React, { FC, useMemo, useState, useCallback, useEffect, useRef } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { TagViewLayout } from './tagViewLayout';
import { PersonalizedTag } from './components/PersonalizedTag';
import { ErrorFrame } from '../../components/error-frames/error-frame';
import { Project, API, Tag, Endpoints } from '@brg/api';
import i18next from 'i18next';
import {
  ProjectsSearchBar,
  ProjectsSearchBarFlex
} from '../../components/projectsSearchBar/projectsSearchBar';
import { bTag, LayoutConst, useModal } from '../../../core';
import { DisplayType } from '../../constants/displayType';
import { SortingTypeIndex } from '../../constants/sortingType';
import { useTranslation } from 'react-i18next';
import { useTag } from '../../hooks/api/useTagsByEntity';
import { AGEYTOMESH_TAG_ID } from "../../constants/misc";
import { AppTester } from "../../../supporting";
import { TagAdminProjectsSearchBar } from 'shared/components/tagAdminProjectsSearchBar';
import { bArray, bProfile, ProfileRole, useAuth, useProfile } from '@brg/auth';
import useExtraFilter from "../../hooks/useExtraFilter";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { MobileFilterSort } from '../explore/styles';
import { SortIcon } from 'shared/icons';
import { ThemeProvider, useTheme } from 'styled-components';
import useQueryState from 'shared/hooks/useQueryState';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { getContextTagsFilterParam } from '../exploreHseContextsOldDeprecated/const/contexts';
import urlApi from 'shared/actions/urlApi';
import { useDispatch, useSelector } from 'react-redux';
import { SUPERPUPER_SORTING_IDX } from "../exploreHseContextsNew/const/sorting_tsx";
import { DEZIIIGN_MAIN_IDX } from '../exploreHseContextsOldDeprecated/const/sorting_tsx';
import MetaTags from 'shared/components/MetaTags';
import TagPageSlice, { TagPageSelector } from 'shared/reducers/TagPageSlice';
import { TagPageSwitcher } from './components/TagPageSwitcher';
import { TagContent } from './tagContent';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';
import { createThemeByColor } from 'shared/helpers/coloring';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { OptionProps } from '_competition/pages/AllCompetitionsPage/types';
import { getEnumOptions } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { STATUSES } from '_competition/const';
import { MobileSortBar, TagArrowIcon, TagTitleText, TagTitleWrapper, TagWrapper } from './components/styles';
import { InfinityProjectsActions, InfinityProjectsSelector } from 'shared/reducers/InfinityProjectsNew';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { useIsBriefAvailable } from 'shared/hooks/api/useIsBriefAvailable';
import { isExpertByPolicy, isTagExpert, isTagExpertByPolicy, isTagModerByPolicy } from 'shared/helpers/utils/TagsUtils';
import { setIsOpen } from 'shared/reducers/OpenModal';
import { current } from '@reduxjs/toolkit';
import { fetchTagPageProjectsCount } from 'shared/actions/tagPageActions';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { TagEditButton } from 'shared/components/tagAdminProjectsSearchBar/styles';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import NotFoundPage from '../notfound';
import CampusExpert from '../CampusExpert/CampusExpert';
import { getFrCampusTypeFromDomain, MAIN_CAMPUS_ID } from '../CampusExpert/const';
import { GtTypesFr } from '../teams/const/GtTypes';

export enum tagPageCategories {
  bestProjects = 'bestProjects',
  portfolio = 'portfolio',
  education = 'education',
  competitions = 'competitions',
  experts = 'experts',
  organizations = 'organizations',
  ftbl = 'ftbl',
}

const LABORATORY_PARAM = '_lab';
const CONTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';

const DEZIIGN_SORTING_IDX = {
  1: 18,
  2: 15,
  18: 18,
  15: 15,
  20: 20,
  26: 26,
  30: 30
}

const HSE_SORTING_IDX = {
  1: 18,
  2: 15,
  18: 18,
  15: 15,
  20: 20,
  26: 26,
  30: 30
}

const initialCheckboxs = {
  approved: false,
  notApproved: false,
  notModerated: false,
  temp: false,
  teachersOnly: false,
}

type PropsT = {
  className?: any;
}

interface ICheckboxsType {
  approved: boolean;
  notApproved: boolean;
  notModerated: boolean;
  temp: boolean;
  teachersOnly: boolean;
}

export const TagView: FC<PropsT> = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation();
  const breakpoint = useBreakpoint(LayoutConst.screen.m);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const theme1 = useTheme();
  const profile = useProfile();
  const history = useHistory();
  const {
    isAKI,
    isHSEDesign,
    isHseSpace,
  } = useAppTester();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isGeograffee = AppTester.isGeograffee();
  const isDeziiign = AppTester.isDeziiign() && !isHSEDesign && !isAgeyTomesh;
  const isDeziignMain = AppTester.isDeziiignMain();
  const isCreative = AppTester.isAcademy();
  const isSuperPuper = AppTester.isSuperPuper();
  const isEducation = AppTester.isGeoDafes();
  const isBooks = AppTester.isBooks();
  const isExam = AppTester.isExamHSE();
  const isLPU = AppTester.isLPUDesign();
  const isMedia = AppTester.isMediiia();
  const isGreenAward = AppTester.isGreenAward();
  const isTagExpertPage = !!useRouteMatch('/tag-expert');
  const isAnyFrContour = AppTester.isFr();
  const isFrShowcasePage = isAnyFrContour && isTagExpertPage;

  const [isBriefUser] = useIsBriefAvailable();

  const { currentCategory, categoryProjectsCount } = useSelector(TagPageSelector);
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;

  const bgColor = useMemo(() => {
    if (currentCategory === tagPageCategories.competitions) {
      return Colors.galBlack80;
    }
    if (theme1.app.backgroundColor === Colors.gal) {
      return Colors.galBlack10;
    }
    return theme1.app.backgroundColor;
  }, [theme1, currentCategory, isMedia]);

  const { theme } = createThemeByColor(bgColor, theme1);

  const [queryParams, setQueryParams] = useQueryState();

  const storedSorting = localStorage.getItem('brg_sorting');

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      //Предыдущая система ролевого доступа
      const isCompetitionModer = profile.rolesList && bArray.isArray(profile.rolesList) && profile.rolesList.some(x => x === "competitionmoder");

      return bProfile.isModer(profile) || hasPolicyCompetitionModer || isCompetitionModer;
    }
  }, [profile])

  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])


  const defaultSorting = useMemo(() => {
    // if (AppTester.isDeziiignContext()) {
    //   return 1;
    // }
    // return storedSorting || 20;
    return 20;
  }, []);

  const canVisibleBriefs = useMemo(
    () => isBriefModer || isBriefUser || isModer, [isBriefModer, isModer, isBriefUser])

  const {
    page: currentPage = 1,
    approved = false,
    notApproved = false,
    notModerated = false,
    moderatedBy = '',
    createdFrom = '',
    createdTo = '',
    temp = false,
    sorting = defaultSorting,
    teachersOnly,
    campusType: campusId
  } = queryParams;

  const checkboxsFilters = {
    approved,
    notApproved,
    notModerated,
    temp,
  }

  const setCheckboxsFilters = useCallback((filters: ICheckboxsType & { campusType?: string }) => {
    setQueryParams({ ...filters }, { replace: true })
  }, [setQueryParams, id])

  const setFilterParam = useCallback((field: string, value: any) => {
    setQueryParams({ [field]: value }, { replace: true })
  }, [
    setQueryParams,
  ])

  const [date, setDate] = useState(Date.now());
  const [projects, setProjects] = useState<Project[]>([]);
  const [extraFilter, onExtraFilterChange] = useExtraFilter();
  const { tabs, tags: contextTags, initialTab } = useContextsTabs();
  const [currentTab, setCurrentTab] = useState<any>(initialTab);
  const isCreativeSpace = AppTester.isCreativeSpace();
  const [{ tab }] = useQueryState();

  const categoryRef = useRef<any>(null);

  const tagRequest = useMemo(() => ({ idTag: id }), [id])

  const isLaboratoryPage = window.location.href.split('?').find((i) => i === LABORATORY_PARAM)
  const labContext = useMemo(() => isLaboratoryPage && { contexts: 'hselab' }, [isLaboratoryPage])

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES, t), [t]);

  const convertSorting = useCallback((sorting: any) => {
    if (isDeziignMain) {
      //@ts-ignore
      return DEZIIIGN_MAIN_IDX[sorting];
    }
    if (isSuperPuper) {
      //@ts-ignore
      return SUPERPUPER_SORTING_IDX[sorting];
    }
    if (isDeziiign) {
      //@ts-ignore
      return DEZIIGN_SORTING_IDX[sorting]
    }
    //@ts-ignore
    return HSE_SORTING_IDX[sorting];
  }, [isHSEDesign, isDeziiign, sorting, isDeziignMain])

  const isOnlines = AppTester.isOnlines();
  const isGeo = AppTester.isGeograffee();
  const [card, setCard] = useState<any>();
  const tagRef = useRef<string | null>(null);
  const modal = useModal();

  const [theTag, tagIsLoading, tagRequestErrored] = useTag(tagRequest, i18next.language, date);

  const tagDescription = useMemo(() => (theTag?.description), [theTag]);

  const isCityTag = useMemo(() => theTag?.groupIds.find((item: string) => item === 'dc762a78dac54369b91542bcbe86bb2a'), [theTag])

  const displayTagPageLikeCtx = useMemo(
    () => (isCreative && isCityTag && !!tagDescription?.length), [isCreative, tagDescription])

  const currentCampusId: string[] = useMemo(() => {
    const domainCampusType = getFrCampusTypeFromDomain();
    if (domainCampusType) {
      return [domainCampusType];
    }
    if (!AppTester.isFr() || !isTagExpertPage) {
      return [];
    }
    if (!campusId || campusId === MAIN_CAMPUS_ID) {
      return [...GtTypesFr.map((item) => item.value)];
    }
    return [campusId];
  }, [campusId, isTagExpertPage]);

  const getCampusGlobalTypes = useCallback((): { globalTypes: string[] } | {} => {
    if (currentCampusId?.length) {
      return {};
    }
    const domainCampusType = getFrCampusTypeFromDomain();
    if (domainCampusType) {
      return { globalTypes: [domainCampusType] };
    }
    return {};
  }, [currentCampusId]);

  const [tags, setTags] = useState<Tag[]>([]);
  const [isTagsLoading, setIsTagsLoading] = useState(false);
  //@ts-ignore
  const isTagCategory = theTag?.isTagCategory
  const isEducationCategory = currentCategory === tagPageCategories.education
  const isOrganizationsCategory = currentCategory === tagPageCategories.organizations

  const onDescriptionEdit = useCallback(() => {
    modal.show('tag-description-edit', { tagId: theTag?.tagId })
  }, [theTag])

  const showShop = AppTester.isGalllleryArt() || AppTester.isDeziiignMain() || AppTester.isHSEDesign() ||
    AppTester.isAcademy() || AppTester.isMediiia() || AppTester.isGeoDafes() || AppTester.isProDeziiign();

  async function getTags() {
    setTags([]);
    setIsTagsLoading(true);

    if (theTag?.groupIds?.length) {
      try {
        const resp = await API.request()
          .endpoint(Endpoints.tagsMnePw)
          .url('/api/tags/GetTags')
          .addQuery('tagIds', theTag.groupIds)
          .addQuery('isIgnoreCanonical', 'true')
          .get()
          .send();
        const data = await resp.json();
        setTags(API.toLang(data, i18n.language));
      } catch (e) {
        console.error(e);
        setTags([]);
      } finally {
        setIsTagsLoading(false);
      }
    } else {
      setTags([]);
      setIsTagsLoading(false);
    }
  }

  useEffect(() => {
    if (!isTagCategory) {
      getTags();
    } else {
      setTags([]);
      setIsTagsLoading(false);
    }
  }, [theTag, i18n.language, isTagCategory]);

  const tagsContent = useMemo(() => {
    return tags?.map(tag => {

      if (isTagCategory) {
        return null
      }
      return <TagWrapper onClick={() => {
        history.push(CreateLinkTo.tag(tag.tagId));
      }}>
        <TagTitleText>{String(bTag.title(tag))}</TagTitleText>

      </TagWrapper>
    })
  }, [tags, isTagCategory, history])

  useEffect(() => {
    // @ts-ignore
    if (theTag?.isTeamTag) {
      // @ts-ignore
      const teamRoute = theTag.additionalInfo?.team_route;

      if (!!teamRoute) {
        // @ts-ignore
        if (teamRoute.toLowerCase().startsWith("http")) {
          window.location.replace(teamRoute);
        } else {
          window.location.replace("https://" + teamRoute);
        }
      } else {
        // @ts-ignore
        const teamContextName = theTag.additionalInfo?.team_contextname;

        if (!!teamContextName) {
          history.replace("/teams/" + teamContextName);
        }
      }
    }
  }, [theTag]);

  const disabledOwnerModerCondition = useMemo(() => (displayTagPageLikeCtx && isCreative), [displayTagPageLikeCtx, isCreative])

  const initialSorting = useMemo(
    () => [tagPageCategories.competitions]?.includes(currentCategory) ? STATUSES.Open : undefined, [currentCategory])

  const isFtbl = AppTester.isFtbl();

  useEffect(() => {
    // if (displayTagPageLikeCtx) {
    if (tagRef.current !== id) {
      setCard(null)
      setDate(Date.now())
      dispatch(TagPageSlice.actions.setCurrentPage(isFtbl ? tagPageCategories.ftbl : tagPageCategories.portfolio))
    }
    tagRef.current = id
    // }
  }, [tagRef, id, displayTagPageLikeCtx, isFtbl])

  useEffect(() => {
    if (is743) {
      const handlePopState = (event: PopStateEvent) => {
        if (!event.state) {
          dispatch(setIsOpen(false));
        } else {
          dispatch(setIsOpen(true));
        }
      };
      window.onpopstate = handlePopState;
    }

    return () => {
      window.onpopstate = null;
    };
  }, [dispatch, is743]);

  //@ts-ignore
  const isTagOwnerOrModer = useMemo(() => (!disabledOwnerModerCondition && profile && ((profile.tagListId && profile.tagListId.includes(theTag?.tagId)) || (profile.tagListId_Expert && profile.tagListId_Expert.includes(theTag?.tagId)) ||
    isTagModerByPolicy(profile, theTag?.tagId) ||
    bProfile.isModer(profile) ||
    bProfile.isMiddleModer(profile)))
    , [profile, disabledOwnerModerCondition, theTag])

  //@ts-ignore
  const isExpertOrModer = useMemo(() => (profile && (
    isTagExpert(profile, id)
    || isTagExpertByPolicy(profile, id)
    || isExpertByPolicy(profile, theTag?.groupIds)
    || bProfile.isModer(profile)
    || bProfile.isMiddleModer(profile)
  )), [id, profile, theTag?.groupIds])

  const shouldVisibleAdminTools = useMemo(
    () => ((isTagOwnerOrModer || isExpertOrModer) && [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory))
    , [isTagOwnerOrModer, currentCategory, isExpertOrModer])

  const sortOffset = useMemo(
    () => breakpoint && [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools ? 0 : 16, [currentCategory, shouldVisibleAdminTools, breakpoint])

  const sortOffsetBottom = useMemo(
    () =>
      breakpoint &&
        [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools ? 0 :
        [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) ? 16 : 0, [currentCategory, breakpoint, shouldVisibleAdminTools])

  const getTranslatedTabs = (tabs: any) => {
    const res: { [key: string]: string } = {};
    const options = null;
    //@ts-ignore
    tabs?.forEach((tab: any, idx) => {
      if (isFtbl) return;
      //@ts-ignore
      res[`${tab}`] = t(`tab_names.${tab}`, options);
    })

    return res;
  }

  const TagTabs = useMemo(() => {
    if (!!tabs?.length) {
      return (
        <SlideNavigation
          activeIndexKey={currentTab}
          onChange={(tab) => {
            setCurrentTab(tab as string);
            setQueryParams({ page: 1, tab }, { replace: true });
            // sessionStorage.setItem('lastTab', tab)
          }}
          items={getTranslatedTabs(tabs)}
          isLoading={false}
        />
      )
    }
  }, [tabs, currentTab,isFtbl, setQueryParams, setCurrentTab, getTranslatedTabs])

  const creativeTagIds = useMemo(
    () => {
      if (contextTags) {
        const tagIds = getContextTagsFilterParam(contextTags[isMobile ? tab : currentTab]);
        if (!tagIds) return false;
        return { tagIds }
      }
    }
    , [currentTab, tab, contextTags, isMobile]
  )

  const serialzeTab = useMemo(() => {
    if (displayTagPageLikeCtx) {
      return isMobile ? tab : currentTab
    }
    return false;

  }, [displayTagPageLikeCtx, isMobile, currentTab, tab])

  const isUniversity = theTag?.entityTypes?.includes('university_category');

  const baseFilter = useMemo(() => {
    return {
      ...((isCreative && displayTagPageLikeCtx) ? {
        projectStatus: [1],
        requiredTagIds: [id],
        // isLite: true,
        limit: 40,
        isContextIgnored: true,
        projectFilter: convertSorting(sorting),
        ...creativeTagIds,
        // ...exceptionTags,
        ...extraFilter,
      } : {
        ...labContext,
        projectFilter: (isOnlines || isEducation) ? sorting : convertSorting(sorting),
        projectStatus: [1],
        ...(!!currentCampusId?.length ? {
          globalTypes: currentCampusId,
        } : {tagIds: [id]}),
        // isLite: true,
        isContextIgnored: true,
        ...(isGeo && {
          isContextIgnored: true,
          appNameIgnore: true,
          // hasGeoTag: true,
        }),
        limit: 40,
        approved: checkboxsFilters.approved,
        notApproved: checkboxsFilters.notApproved,
        notModerated: checkboxsFilters.notModerated,
        moderatedBy: moderatedBy,
        publishedFrom: createdFrom,
        publishedTo: createdTo,
        hasProductCards: Number(sorting) === Number(SortingTypeIndex.shop),
        onlyBooks: '',
        ...extraFilter,
        ...(!isTagOwnerOrModer && !isExpertOrModer && isHSEDesign && {
          globalTypes: ['student', 'employee', 'cooperator', 'hsealumni', ...(isHseSpace ? ['externalhse'] : [])],
        }),
        ...(isGeograffee && !isEducation && {
          hascities: true,
          hasgeoplaces: true
        }),
        ...(isEducation && isUniversity && {
          isContextIgnored: true,
          globalTypes: [],
        }),
        ...(isBooks && {
          isContextIgnored: true,
          globalTypes: [],
        }),
        ...(isExam && {
          globalTypes: [],
        }),
        ...(isLPU && {
          globalTypes: ['lpuemployee'],
        }),
        ...(isGreenAward && {
          globalTypes: ['greenawards'],
        }),
        ...(isCreativeSpace && {
          globalTypes: ['Hsecreativestudent'],
        }),
      })
    }
  }, [
    sorting,
    id,
    currentCampusId,
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    moderatedBy,
    createdFrom,
    createdTo,
    extraFilter,
    labContext,
    isHSEDesign,
    isDeziiign,
    isCreative,
    isSuperPuper,
    creativeTagIds,
    displayTagPageLikeCtx,
    currentCategory
  ])

  const getFiltersForTabs = useCallback((categories: tagPageCategories[]) => {
    return categories?.map((tab) => {
      if (tab === tagPageCategories.bestProjects) {
        return {
          ...baseFilter,
          isContextIgnored: false,
          contexts: isAKI ? ['aki'] :
            isSuperPuper ? ['superpuper'] :
              checkboxsFilters.temp ? ['hsedesigntemp'] :
                isAgeyTomesh ? ['ageytomesh'] :
                  ["hsedesign"],
          ...getCampusGlobalTypes(),
          requestTab: tagPageCategories.bestProjects,
        }
      }
      if (tab === tagPageCategories.portfolio) {
        return {
          ...baseFilter,
          ...(isAKI && {
            contexts: ['aki'],
            isContextIgnored: false,
          }),
          // при temp — hsedesigntemp
          ...(checkboxsFilters.temp && {
            contexts: ['hsedesigntemp'],
            isContextIgnored: false,
          }),
          // при ageytomesh — ageytomesh
          ...(isAgeyTomesh && {
            contexts: ['ageytomesh'],
            isContextIgnored: false,
          }),
          ...getCampusGlobalTypes(),
          requestTab: tagPageCategories.portfolio,
        };
      }
      if (tab === tagPageCategories.ftbl) {
        return {
          ...baseFilter,
          isContextIgnored: false,
          contexts: ['ftbl'],
        };
      }
      if (tab === tagPageCategories.competitions) {
        return {
          projectsFilter: Number(sorting) === 1 ? [
            STATUSES.Open,
            STATUSES.Voting
          ] : [sorting]
        }
      }
      else {
        return {
          projectsFilter: sorting
        }
      }
    })
  }, [
    sorting,
    id,
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    moderatedBy,
    createdFrom,
    createdTo,
    extraFilter,
    labContext,
    isHSEDesign,
    isAKI,
    isDeziiign,
    isCreative,
    isSuperPuper,
    creativeTagIds,
    displayTagPageLikeCtx,
    currentCategory,
    baseFilter
  ])

  useEffect(() => {
    if (theTag) {
      setDate(Date.now())
    }
  }, [id, sorting])

  useEffect(() => {
    if (categoryRef && categoryRef.current !== currentCategory) {
      setQueryParams({ sorting: initialSorting }, { replace: true });
      categoryRef.current = currentCategory;
    }
  }, [currentCategory, setQueryParams, initialSorting, categoryRef])

  useEffect(() => {
    dispatch(TagPageSlice.actions.setModerOrExpert(isExpertOrModer || isTagOwnerOrModer || false))
  }, [isExpertOrModer, isTagOwnerOrModer, dispatch, theTag])


  useMemo(() => setCurrentTab(initialTab), [initialTab])

  const requiredFields = useMemo(() =>
    ({ createdFrom, createdTo, teachersOnly, sorting })
    , [createdFrom, sorting, createdTo, teachersOnly])

  useEffect(() => {
    dispatch(fetchTagPageProjectsCount(
      {
        filters: getFiltersForTabs([tagPageCategories.bestProjects, tagPageCategories.portfolio]),
        tagId: id,
      }
    ))

  }, [
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    id,
    currentCampusId,
    temp,
    requiredFields,
    createdFrom,
    createdTo,
    moderatedBy
  ])

  useEffect(() => {
    if (!(isTagOwnerOrModer || isExpertOrModer)) {
      setCheckboxsFilters({
        ...initialCheckboxs
      });
    }
  }, [isTagOwnerOrModer, isExpertOrModer, setCheckboxsFilters]);

  const onApprovedHsedesign = useCallback((value: boolean): void => {
    //@ts-ignore
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      approved: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: campusId } : {})
    })
  }, [requiredFields, campusId, currentCampusId]);

  const getCampusIdParam = (currentCampusId: string[]) => {
    if (!currentCampusId ||currentCampusId?.length > 1) {
      return 'main'
    }
    return currentCampusId[0] || 'main'
  }

  const onNotApprovedHsedesign = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      notApproved: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, currentCampusId, campusId]);

  const onNotModerated = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      notModerated: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, campusId, currentCampusId]);

  const onTemp = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      temp: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, currentCampusId]);

  const onModeratedBy = useCallback((value: string): void => {
    setFilterParam('moderatedBy', value);
  }, []);

  const onCreatedFrom = useCallback((value: string): void => {
    setFilterParam('createdFrom', value);
  }, []);

  const onMonthChange = useCallback((value: string): void => {
    setFilterParam('month', value);
  }, []);

  const onYearChange = useCallback((value: string): void => {
    setFilterParam('year', value);
  }, []);

  const onCreatedTo = useCallback((value: string): void => {
    setFilterParam('createdTo', value);
  }, []);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    const prevData = { approved, notApproved, notModerated, moderatedBy, createdFrom, createdTo, temp, sorting, teachersOnly };
    //@ts-ignore
    setCheckboxsFilters({ ...prevData, sorting: s, ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
    localStorage.setItem('brg_sorting', String(s))
  }, [
    approved, notApproved, notModerated, moderatedBy, createdFrom, createdTo, temp, sorting, teachersOnly, id, currentCampusId
  ]);

  const onMobileSortingClick = useCallback((s: any) => {
    let newSort

    if ([tagPageCategories.competitions]?.includes(currentCategory)) {
      newSort = sorting == 5 ? 1 : 5
    } else {
      newSort = sorting == 1 ? 2 : sorting == 2 ? 26 : sorting == 26 ? 20 : sorting == 20 ? 30 : 1
    }
    // const newSort = ![tagPageCategories.competitions]?.includes(currentCategory) ? sorting == 1 ? 2 : sorting == 2 ? 20 : 1 : 
    // (
    //   sorting == 5 ? 1 : 5
    // )

    localStorage.setItem('brg_sorting', String(newSort))
    setFilterParam('sorting', newSort);
  }, [sorting, setFilterParam, currentCategory]);

  const onProjectsCountSet = useCallback((n: number) => {
    dispatch(TagPageSlice.actions.setCategoryProjectsCount(n))
  }, [dispatch])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier }, { replace: true })
  }, [setQueryParams])

  // useEffect(() => {
  //   if (displayTagPageLikeCtx) {
  //     setQueryParams({ tab: id })
  //   }
  // } , [id, displayTagPageLikeCtx])

  useEffect(() => {
    if (isProjectPage) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
  }, [isProjectPage, dispatch])

  const disableMobileSortOffset = useMemo(() => {
    if (!is743) {
      if ([tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools) return false
      else if ([tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory)) return true;
      return ![tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory)
    }
    return true
  }, [is743, currentCategory, shouldVisibleAdminTools])

  const mobileSearch = useMemo(() => (
    <MobileSortBar
      directionMobile='row'
      offsetTopMobile={sortOffset}
      offsetBottomMobile={sortOffsetBottom}
      disableOffset={disableMobileSortOffset}
      justifyMobile='flex-end'
      widthMobile={'100%'}
    >
      <MobileFilterSort style={{ marginRight: 0 }} onClick={onMobileSortingClick}>
        <SortIcon />
        {![tagPageCategories.competitions]?.includes(currentCategory) ? (
          t(`sorting_type.${sorting == 1 ? 'latest' : sorting == 2 ? 'rating' : sorting == 26 ? 'popular' : sorting == 20 ? 'relevant' : sorting == 30 ? 'shop' : 'popular'}`)
        ) : (
          t(`sorting_type.${sorting == 5 ? 'ended_competition' : 'current_competition'}`)
        )}
      </MobileFilterSort>
    </MobileSortBar>
  ), [t, currentCategory, onMobileSortingClick, disableMobileSortOffset, shouldVisibleAdminTools, sorting, sortOffset, sortOffsetBottom])


  const sortingMethods = useMemo(() => {
    const shopMethod = showShop ? [30] : [];
    if (AppTester.isDeziiignContext()) {
      return [1, 2, 26, ...shopMethod];
    }
    return [1, 2, 26, 20, ...shopMethod];
  }, [showShop]);

  const searchBar = useMemo(
    () => {
      if (currentCategory === tagPageCategories.experts || isEducationCategory || isOrganizationsCategory) {
        return null;
      }
      if ([tagPageCategories.competitions]?.includes(currentCategory)) {
        return (
          <CompetitionDropdown
            selectedSorting={sorting}
            onSortingChange={onChangeStatus}
            sortingMethods={statusesOptions}
            isDarkTheme={true}
          />
        )
      }

      return (
        <ProjectsSearchBar
          isLoading={false}
          isCategoriesHidden
          sorting={sorting}
          hideRightButtons
          hideLeftBar={true}
          extraFilter={extraFilter}
          onExtraFilterChange={onExtraFilterChange}
          onSortingChange={onSortingChange}
          display={DisplayType.grid}
          isTagPage
          isTagOwnerOrModer={isTagOwnerOrModer}
          // projectCount={projectCount}
          column={!breakpoint}
          sortingMethods={sortingMethods}
          isDarkTheme={isGeo || !(theme as { isDarkText?: boolean }).isDarkText}
        />
      )
    },
    [
      sorting,
      onSortingChange,
      categoryProjectsCount,
      currentCategory,
      extraFilter,
      onExtraFilterChange,
      isEducationCategory,
      isOrganizationsCategory,
      isGeo,
      theme,
    ],
  );

  const filtersContent = useMemo(() => {
    if (isFtbl) return null;
    const tabCondition = (
      ([
        tagPageCategories.portfolio,
        tagPageCategories.bestProjects
      ]
        ?.includes(currentCategory)
        && shouldVisibleAdminTools) ||
      ([
        tagPageCategories.experts,
        tagPageCategories.education,
        tagPageCategories.organizations,
      ])?.includes(currentCategory)
    )

    const offsetBottom = isMedia ? 16 :
      (
        currentCategory === 'portfolio' ||
          currentCategory === 'bestProjects' ||
          currentCategory === 'experts' ||
          currentCategory === 'organizations'
          ? 16 : 0
      )

    if (tabCondition) {
      return (
        <FlexBox
          align='end'
          offsetBottomMobile={offsetBottom}
          justify="space-between"
          direction='row'
          directionMobile={'row'}
        >
          {!displayTagPageLikeCtx && <TagPageSwitcher />}
          {(breakpoint ? mobileSearch : searchBar)}
        </FlexBox>
      )
    } else {
      return (
        <FlexBox
          align='end'
          offsetBottomMobile={offsetBottom}
          justify="space-between"
          direction='row'
          directionMobile={'row'}
        >
          {!displayTagPageLikeCtx && <TagPageSwitcher />}
          {(breakpoint ? mobileSearch : searchBar)}
        </FlexBox>
      )
    }
  }, [
    isTagOwnerOrModer,
    shouldVisibleAdminTools,
    displayTagPageLikeCtx,
    categoryProjectsCount,
    currentCategory,
    breakpoint,
    isMedia,
    is743,
    mobileSearch,
    breakpoint,
    searchBar,
    isFtbl
  ])

  const content = useMemo(() => {
    return (
      <TagContent
        id={id}
        filter={getFiltersForTabs([currentCategory])?.[0]}
        category={currentCategory}
        onProjectsLoaded={(p) => setProjects(p)}
        projects={projects}
        setProjectCount={onProjectsCountSet}
        date={date}
        isModer={canVisibleBriefs}
        isInfinityNeed={true}
        currentTab={serialzeTab}
        externalPageParam
        isTagCategory={isTagCategory}
        tagIsLoading={tagIsLoading}
      />
    )
  }, [
    id,
    currentCategory,
    canVisibleBriefs,
    date,
    serialzeTab,
    onProjectsCountSet,
    getFiltersForTabs,
    projects
  ])

  const tagAdminSearchBar = useMemo(() => {
    if (!shouldVisibleAdminTools) return null;
    return (
      //@ts-ignore
      ((isTagOwnerOrModer || isExpertOrModer) ? (
        <FlexBox
          direction="column"
          directionMobile="column"
          offsetTop={24}
          gy={24}
          gyMobile={0.01}
          width="100%"
        >
          <TagAdminProjectsSearchBar
            approved={checkboxsFilters.approved}
            notApproved={checkboxsFilters.notApproved}
            notModerated={checkboxsFilters.notModerated}
            filter={baseFilter?.globalTypes}
            temp={checkboxsFilters.temp}
            moderatedBy={moderatedBy}
            tagId={id}
            // createdFrom={createdFrom}
            // createdTo={createdTo}
            onApprovedHsedesign={onApprovedHsedesign}
            onNotApprovedHsedesign={onNotApprovedHsedesign}
            onNotModerated={onNotModerated}
            onTemp={onTemp}
            onModeratedBy={onModeratedBy}
            onCreatedFrom={onCreatedFrom}
            onMonthChange={onMonthChange}
            onYearChange={onYearChange}
            onCreatedTo={onCreatedTo}
            extraFilter={extraFilter}
            onExtraFilterChange={onExtraFilterChange}
            filterContent={/*!breakpoint && */(breakpoint ? (!isMedia && mobileSearch) : searchBar)}
          />
        </FlexBox>
      ) : (
        <ProjectsSearchBarFlex gx={24} style={{ display: isMobile ? 'none' : 'flex' }}>
          <FInter.SmallTextMagic
            style={{ fontSize: '15px', lineHeight: '20px', fontWeight: '700', whiteSpace: 'nowrap' }}
            align={'center'}
            color={theme.allTagsBtn.colorHover}>
            {t('filter.projects') + '' + `(${categoryProjectsCount || 0})`}
          </FInter.SmallTextMagic>
        </ProjectsSearchBarFlex>
      ))
    )
  },
    [profile,
      theTag,
      onApprovedHsedesign,
      onNotApprovedHsedesign,
      onNotModerated,
      onModeratedBy,
      onCreatedFrom,
      onCreatedTo,
      checkboxsFilters,
      moderatedBy,
      breakpoint,
      id,
      categoryProjectsCount,
      isExpertOrModer,
      isTagOwnerOrModer
    ],
  );

  if (id === AGEYTOMESH_TAG_ID) {
    window.location.replace('https://ageytomesh.com');
  }

  if (tagIsLoading) {
    return <TagViewLayout theme={theme} bgColor={bgColor} isLoading={true} />
  }

  if (isFrShowcasePage) {
    return <CampusExpert 
      tagAdminFiltersContent={tagAdminSearchBar}
      content={content}
    />
  }

    // Обработка ошибок
  if (tagRequestErrored && !isFrShowcasePage) {
    return <NotFoundPage />
  }

  const isPersonalized = !!(theTag as any)?.isPersonalized;

  return (
    <>
      <MetaTags
        title={String(bTag.title(theTag))}
        canonicalInfo={(theTag as any)?.canonicalInfo}
      />
      <TagViewLayout
        key={id}
        //todo разобраться с темами
        theme={theme}
        bgColor={bgColor}
        isLoading={tagIsLoading}
        isTagsLoading={isTagsLoading}
        tagsContent={tagsContent}
        title={String(bTag.title(theTag))}
        filtersContent={filtersContent}
        tagAdminFiltersContent={tagAdminSearchBar}
        //@ts-ignore
        openLikeCtx={!isPersonalized && displayTagPageLikeCtx}
        description={tagDescription}
        tagCard={card}
        tagTabsContent={TagTabs}
        projectsContent={content}
        isTagOwnerOrModer={isTagOwnerOrModer || isTagExpert || isTagExpertByPolicy}
        id={id}
        headerContent={isPersonalized ? (
          <PersonalizedTag
            tag={theTag}
            isLoading={tagIsLoading}
            theme={theme1}
          />
        ) : undefined}
      />
    </>
  );
};
import React, { FC, useMemo, useState, useCallback, useEffect, useRef } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { TagViewLayout } from './tagViewLayout';
import { PersonalizedTag } from './components/PersonalizedTag';
import { ErrorFrame } from '../../components/error-frames/error-frame';
import { Project, API, Tag, Endpoints } from '@brg/api';
import i18next from 'i18next';
import {
  ProjectsSearchBar,
  ProjectsSearchBarFlex
} from '../../components/projectsSearchBar/projectsSearchBar';
import { bTag, LayoutConst, useModal } from '../../../core';
import { DisplayType } from '../../constants/displayType';
import { SortingTypeIndex } from '../../constants/sortingType';
import { useTranslation } from 'react-i18next';
import { useTag } from '../../hooks/api/useTagsByEntity';
import { AGEYTOMESH_TAG_ID } from "../../constants/misc";
import { AppTester } from "../../../supporting";
import { TagAdminProjectsSearchBar } from 'shared/components/tagAdminProjectsSearchBar';
import { bArray, bProfile, ProfileRole, useAuth, useProfile } from '@brg/auth';
import useExtraFilter from "../../hooks/useExtraFilter";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { MobileFilterSort } from '../explore/styles';
import { SortIcon } from 'shared/icons';
import { ThemeProvider, useTheme } from 'styled-components';
import useQueryState from 'shared/hooks/useQueryState';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { getContextTagsFilterParam } from '../exploreHseContextsOldDeprecated/const/contexts';
import urlApi from 'shared/actions/urlApi';
import { useDispatch, useSelector } from 'react-redux';
import { SUPERPUPER_SORTING_IDX } from "../exploreHseContextsNew/const/sorting_tsx";
import { DEZIIIGN_MAIN_IDX } from '../exploreHseContextsOldDeprecated/const/sorting_tsx';
import MetaTags from 'shared/components/MetaTags';
import TagPageSlice, { TagPageSelector } from 'shared/reducers/TagPageSlice';
import { TagPageSwitcher } from './components/TagPageSwitcher';
import { TagContent } from './tagContent';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';
import { createThemeByColor } from 'shared/helpers/coloring';
import { CompetitionDropdown } from '_competition/components/CompetitionDropdown';
import { OptionProps } from '_competition/pages/AllCompetitionsPage/types';
import { getEnumOptions } from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';
import { STATUSES } from '_competition/const';
import { MobileSortBar, TagArrowIcon, TagTitleText, TagTitleWrapper, TagWrapper } from './components/styles';
import { InfinityProjectsActions, InfinityProjectsSelector } from 'shared/reducers/InfinityProjectsNew';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { useIsBriefAvailable } from 'shared/hooks/api/useIsBriefAvailable';
import { isExpertByPolicy, isTagExpert, isTagExpertByPolicy, isTagModerByPolicy } from 'shared/helpers/utils/TagsUtils';
import { setIsOpen } from 'shared/reducers/OpenModal';
import { current } from '@reduxjs/toolkit';
import { fetchTagPageProjectsCount } from 'shared/actions/tagPageActions';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { TagEditButton } from 'shared/components/tagAdminProjectsSearchBar/styles';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import NotFoundPage from '../notfound';
import CampusExpert from '../CampusExpert/CampusExpert';
import { getFrCampusTypeFromDomain, MAIN_CAMPUS_ID } from '../CampusExpert/const';
import { GtTypesFr } from '../teams/const/GtTypes';

export enum tagPageCategories {
  bestProjects = 'bestProjects',
  portfolio = 'portfolio',
  education = 'education',
  competitions = 'competitions',
  experts = 'experts',
  organizations = 'organizations',
  ftbl = 'ftbl',
}

const LABORATORY_PARAM = '_lab';
const CONTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';

const DEZIIGN_SORTING_IDX = {
  1: 18,
  2: 15,
  18: 18,
  15: 15,
  20: 20,
  26: 26,
  30: 30
}

const HSE_SORTING_IDX = {
  1: 18,
  2: 15,
  18: 18,
  15: 15,
  20: 20,
  26: 26,
  30: 30
}

const initialCheckboxs = {
  approved: false,
  notApproved: false,
  notModerated: false,
  temp: false,
  teachersOnly: false,
}

type PropsT = {
  className?: any;
}

interface ICheckboxsType {
  approved: boolean;
  notApproved: boolean;
  notModerated: boolean;
  temp: boolean;
  teachersOnly: boolean;
}

export const TagView: FC<PropsT> = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation();
  const breakpoint = useBreakpoint(LayoutConst.screen.m);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);
  const theme1 = useTheme();
  const profile = useProfile();
  const history = useHistory();
  const {
    isAKI,
    isHSEDesign,
    isHseSpace,
  } = useAppTester();
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isGeograffee = AppTester.isGeograffee();
  const isDeziiign = AppTester.isDeziiign() && !isHSEDesign && !isAgeyTomesh;
  const isDeziignMain = AppTester.isDeziiignMain();
  const isCreative = AppTester.isAcademy();
  const isSuperPuper = AppTester.isSuperPuper();
  const isEducation = AppTester.isGeoDafes();
  const isBooks = AppTester.isBooks();
  const isExam = AppTester.isExamHSE();
  const isLPU = AppTester.isLPUDesign();
  const isMedia = AppTester.isMediiia();
  const isGreenAward = AppTester.isGreenAward();
  const isTagExpertPage = !!useRouteMatch('/tag-expert');
  const isAnyFrContour = AppTester.isFr();
  const isFrShowcasePage = isAnyFrContour && isTagExpertPage;

  const [isBriefUser] = useIsBriefAvailable();

  const { currentCategory, categoryProjectsCount } = useSelector(TagPageSelector);
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;

  const bgColor = useMemo(() => {
    if (currentCategory === tagPageCategories.competitions) {
      return Colors.galBlack80;
    }
    if (theme1.app.backgroundColor === Colors.gal) {
      return Colors.galBlack10;
    }
    return theme1.app.backgroundColor;
  }, [theme1, currentCategory, isMedia]);

  const { theme } = createThemeByColor(bgColor, theme1);

  const [queryParams, setQueryParams] = useQueryState();

  const storedSorting = localStorage.getItem('brg_sorting');

  const isModer = useMemo(() => {
    if (profile) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      //Предыдущая система ролевого доступа
      const isCompetitionModer = profile.rolesList && bArray.isArray(profile.rolesList) && profile.rolesList.some(x => x === "competitionmoder");

      return bProfile.isModer(profile) || hasPolicyCompetitionModer || isCompetitionModer;
    }
  }, [profile])

  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])


  const defaultSorting = useMemo(() => {
    // if (AppTester.isDeziiignContext()) {
    //   return 1;
    // }
    // return storedSorting || 20;
    return 20;
  }, []);

  const canVisibleBriefs = useMemo(
    () => isBriefModer || isBriefUser || isModer, [isBriefModer, isModer, isBriefUser])

  const {
    page: currentPage = 1,
    approved = false,
    notApproved = false,
    notModerated = false,
    moderatedBy = '',
    createdFrom = '',
    createdTo = '',
    temp = false,
    sorting = defaultSorting,
    teachersOnly,
    campusType: campusId
  } = queryParams;

  const checkboxsFilters = {
    approved,
    notApproved,
    notModerated,
    temp,
  }

  const setCheckboxsFilters = useCallback((filters: ICheckboxsType & { campusType?: string }) => {
    setQueryParams({ ...filters }, { replace: true })
  }, [setQueryParams, id])

  const setFilterParam = useCallback((field: string, value: any) => {
    setQueryParams({ [field]: value }, { replace: true })
  }, [
    setQueryParams,
  ])

  const [date, setDate] = useState(Date.now());
  const [projects, setProjects] = useState<Project[]>([]);
  const [extraFilter, onExtraFilterChange] = useExtraFilter();
  const { tabs, tags: contextTags, initialTab } = useContextsTabs();
  const [currentTab, setCurrentTab] = useState<any>(initialTab);
  const isCreativeSpace = AppTester.isCreativeSpace();
  const [{ tab }] = useQueryState();

  const categoryRef = useRef<any>(null);

  const tagRequest = useMemo(() => ({ idTag: id }), [id])

  const isLaboratoryPage = window.location.href.split('?').find((i) => i === LABORATORY_PARAM)
  const labContext = useMemo(() => isLaboratoryPage && { contexts: 'hselab' }, [isLaboratoryPage])

  const statusesOptions = useMemo(() => getEnumOptions(STATUSES, t), [t]);

  const convertSorting = useCallback((sorting: any) => {
    if (isDeziignMain) {
      //@ts-ignore
      return DEZIIIGN_MAIN_IDX[sorting];
    }
    if (isSuperPuper) {
      //@ts-ignore
      return SUPERPUPER_SORTING_IDX[sorting];
    }
    if (isDeziiign) {
      //@ts-ignore
      return DEZIIGN_SORTING_IDX[sorting]
    }
    //@ts-ignore
    return HSE_SORTING_IDX[sorting];
  }, [isHSEDesign, isDeziiign, sorting, isDeziignMain])

  const isOnlines = AppTester.isOnlines();
  const isGeo = AppTester.isGeograffee();
  const [card, setCard] = useState<any>();
  const tagRef = useRef<string | null>(null);
  const modal = useModal();

  const [theTag, tagIsLoading, tagRequestErrored] = useTag(tagRequest, i18next.language, date);

  const tagDescription = useMemo(() => (theTag?.description), [theTag]);

  const isCityTag = useMemo(() => theTag?.groupIds.find((item: string) => item === 'dc762a78dac54369b91542bcbe86bb2a'), [theTag])

  const displayTagPageLikeCtx = useMemo(
    () => (isCreative && isCityTag && !!tagDescription?.length), [isCreative, tagDescription])

  const currentCampusId: string[] = useMemo(() => {
    const domainCampusType = getFrCampusTypeFromDomain();
    if (domainCampusType) {
      return [domainCampusType];
    }
    if (!AppTester.isFr() || !isTagExpertPage) {
      return [];
    }
    if (!campusId || campusId === MAIN_CAMPUS_ID) {
      return [...GtTypesFr.map((item) => item.value)];
    }
    return [campusId];
  }, [campusId, isTagExpertPage]);

  const getCampusGlobalTypes = useCallback((): { globalTypes: string[] } | {} => {
    if (currentCampusId?.length) {
      return {};
    }
    const domainCampusType = getFrCampusTypeFromDomain();
    if (domainCampusType) {
      return { globalTypes: [domainCampusType] };
    }
    return {};
  }, [currentCampusId]);

  const [tags, setTags] = useState<Tag[]>([]);
  const [isTagsLoading, setIsTagsLoading] = useState(false);
  //@ts-ignore
  const isTagCategory = theTag?.isTagCategory
  const isEducationCategory = currentCategory === tagPageCategories.education
  const isOrganizationsCategory = currentCategory === tagPageCategories.organizations

  const onDescriptionEdit = useCallback(() => {
    modal.show('tag-description-edit', { tagId: theTag?.tagId })
  }, [theTag])

  const showShop = AppTester.isGalllleryArt() || AppTester.isDeziiignMain() || AppTester.isHSEDesign() ||
    AppTester.isAcademy() || AppTester.isMediiia() || AppTester.isGeoDafes() || AppTester.isProDeziiign();

  async function getTags() {
    setTags([]);
    setIsTagsLoading(true);

    if (theTag?.groupIds?.length) {
      try {
        const resp = await API.request()
          .endpoint(Endpoints.tagsMnePw)
          .url('/api/tags/GetTags')
          .addQuery('tagIds', theTag.groupIds)
          .addQuery('isIgnoreCanonical', 'true')
          .get()
          .send();
        const data = await resp.json();
        setTags(API.toLang(data, i18n.language));
      } catch (e) {
        console.error(e);
        setTags([]);
      } finally {
        setIsTagsLoading(false);
      }
    } else {
      setTags([]);
      setIsTagsLoading(false);
    }
  }

  useEffect(() => {
    if (!isTagCategory) {
      getTags();
    } else {
      setTags([]);
      setIsTagsLoading(false);
    }
  }, [theTag, i18n.language, isTagCategory]);

  const tagsContent = useMemo(() => {
    return tags?.map(tag => {

      if (isTagCategory) {
        return null
      }
      return <TagWrapper onClick={() => {
        history.push(CreateLinkTo.tag(tag.tagId));
      }}>
        <TagTitleText>{String(bTag.title(tag))}</TagTitleText>

      </TagWrapper>
    })
  }, [tags, isTagCategory, history])

  useEffect(() => {
    // @ts-ignore
    if (theTag?.isTeamTag) {
      // @ts-ignore
      const teamRoute = theTag.additionalInfo?.team_route;

      if (!!teamRoute) {
        // @ts-ignore
        if (teamRoute.toLowerCase().startsWith("http")) {
          window.location.replace(teamRoute);
        } else {
          window.location.replace("https://" + teamRoute);
        }
      } else {
        // @ts-ignore
        const teamContextName = theTag.additionalInfo?.team_contextname;

        if (!!teamContextName) {
          history.replace("/teams/" + teamContextName);
        }
      }
    }
  }, [theTag]);

  const disabledOwnerModerCondition = useMemo(() => (displayTagPageLikeCtx && isCreative), [displayTagPageLikeCtx, isCreative])

  const initialSorting = useMemo(
    () => [tagPageCategories.competitions]?.includes(currentCategory) ? STATUSES.Open : undefined, [currentCategory])

  const isFtbl = AppTester.isFtbl();

  useEffect(() => {
    // if (displayTagPageLikeCtx) {
    if (tagRef.current !== id) {
      setCard(null)
      setDate(Date.now())
      dispatch(TagPageSlice.actions.setCurrentPage(isFtbl ? tagPageCategories.ftbl : tagPageCategories.portfolio))
    }
    tagRef.current = id
    // }
  }, [tagRef, id, displayTagPageLikeCtx, isFtbl])

  useEffect(() => {
    if (is743) {
      const handlePopState = (event: PopStateEvent) => {
        if (!event.state) {
          dispatch(setIsOpen(false));
        } else {
          dispatch(setIsOpen(true));
        }
      };
      window.onpopstate = handlePopState;
    }

    return () => {
      window.onpopstate = null;
    };
  }, [dispatch, is743]);

  //@ts-ignore
  const isTagOwnerOrModer = useMemo(() => (!disabledOwnerModerCondition && profile && ((profile.tagListId && profile.tagListId.includes(theTag?.tagId)) || (profile.tagListId_Expert && profile.tagListId_Expert.includes(theTag?.tagId)) ||
    isTagModerByPolicy(profile, theTag?.tagId) ||
    bProfile.isModer(profile) ||
    bProfile.isMiddleModer(profile)))
    , [profile, disabledOwnerModerCondition, theTag])

  //@ts-ignore
  const isExpertOrModer = useMemo(() => (profile && (
    isTagExpert(profile, id)
    || isTagExpertByPolicy(profile, id)
    || isExpertByPolicy(profile, theTag?.groupIds)
    || bProfile.isModer(profile)
    || bProfile.isMiddleModer(profile)
  )), [id, profile, theTag?.groupIds])

  const shouldVisibleAdminTools = useMemo(
    () => ((isTagOwnerOrModer || isExpertOrModer) && [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory))
    , [isTagOwnerOrModer, currentCategory, isExpertOrModer])

  const sortOffset = useMemo(
    () => breakpoint && [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools ? 0 : 16, [currentCategory, shouldVisibleAdminTools, breakpoint])

  const sortOffsetBottom = useMemo(
    () =>
      breakpoint &&
        [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools ? 0 :
        [tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) ? 16 : 0, [currentCategory, breakpoint, shouldVisibleAdminTools])

  const getTranslatedTabs = (tabs: any) => {
    const res: { [key: string]: string } = {};
    const options = null;
    //@ts-ignore
    tabs?.forEach((tab: any, idx) => {
      if (isFtbl) return;
      //@ts-ignore
      res[`${tab}`] = t(`tab_names.${tab}`, options);
    })

    return res;
  }

  const TagTabs = useMemo(() => {
    if (!!tabs?.length) {
      return (
        <SlideNavigation
          activeIndexKey={currentTab}
          onChange={(tab) => {
            setCurrentTab(tab as string);
            setQueryParams({ page: 1, tab }, { replace: true });
            // sessionStorage.setItem('lastTab', tab)
          }}
          items={getTranslatedTabs(tabs)}
          isLoading={false}
        />
      )
    }
  }, [tabs, currentTab,isFtbl, setQueryParams, setCurrentTab, getTranslatedTabs])

  const creativeTagIds = useMemo(
    () => {
      if (contextTags) {
        const tagIds = getContextTagsFilterParam(contextTags[isMobile ? tab : currentTab]);
        if (!tagIds) return false;
        return { tagIds }
      }
    }
    , [currentTab, tab, contextTags, isMobile]
  )

  const serialzeTab = useMemo(() => {
    if (displayTagPageLikeCtx) {
      return isMobile ? tab : currentTab
    }
    return false;

  }, [displayTagPageLikeCtx, isMobile, currentTab, tab])

  const isUniversity = theTag?.entityTypes?.includes('university_category');

  const baseFilter = useMemo(() => {
    return {
      ...((isCreative && displayTagPageLikeCtx) ? {
        projectStatus: [1],
        requiredTagIds: [id],
        // isLite: true,
        limit: 40,
        isContextIgnored: true,
        projectFilter: convertSorting(sorting),
        ...creativeTagIds,
        // ...exceptionTags,
        ...extraFilter,
      } : {
        ...labContext,
        projectFilter: (isOnlines || isEducation) ? sorting : convertSorting(sorting),
        projectStatus: [1],
        ...(!!currentCampusId?.length ? {
          globalTypes: currentCampusId,
        } : {tagIds: [id]}),
        // isLite: true,
        isContextIgnored: true,
        ...(isGeo && {
          isContextIgnored: true,
          appNameIgnore: true,
          // hasGeoTag: true,
        }),
        limit: 40,
        approved: checkboxsFilters.approved,
        notApproved: checkboxsFilters.notApproved,
        notModerated: checkboxsFilters.notModerated,
        moderatedBy: moderatedBy,
        publishedFrom: createdFrom,
        publishedTo: createdTo,
        hasProductCards: Number(sorting) === Number(SortingTypeIndex.shop),
        onlyBooks: '',
        ...extraFilter,
        ...(!isTagOwnerOrModer && !isExpertOrModer && isHSEDesign && {
          globalTypes: ['student', 'employee', 'cooperator', 'hsealumni', ...(isHseSpace ? ['externalhse'] : [])],
        }),
        ...(isGeograffee && !isEducation && {
          hascities: true,
          hasgeoplaces: true
        }),
        ...(isEducation && isUniversity && {
          isContextIgnored: true,
          globalTypes: [],
        }),
        ...(isBooks && {
          isContextIgnored: true,
          globalTypes: [],
        }),
        ...(isExam && {
          globalTypes: [],
        }),
        ...(isLPU && {
          globalTypes: ['lpuemployee'],
        }),
        ...(isGreenAward && {
          globalTypes: ['greenawards'],
        }),
        ...(isCreativeSpace && {
          globalTypes: ['Hsecreativestudent'],
        }),
      })
    }
  }, [
    sorting,
    id,
    currentCampusId,
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    moderatedBy,
    createdFrom,
    createdTo,
    extraFilter,
    labContext,
    isHSEDesign,
    isDeziiign,
    isCreative,
    isSuperPuper,
    creativeTagIds,
    displayTagPageLikeCtx,
    currentCategory
  ])

  const getFiltersForTabs = useCallback((categories: tagPageCategories[]) => {
    return categories?.map((tab) => {
      if (tab === tagPageCategories.bestProjects) {
        return {
          ...baseFilter,
          isContextIgnored: false,
          contexts: isAKI ? ['aki'] :
            isSuperPuper ? ['superpuper'] :
              checkboxsFilters.temp ? ['hsedesigntemp'] :
                isAgeyTomesh ? ['ageytomesh'] :
                  ["hsedesign"],
          ...getCampusGlobalTypes(),
          requestTab: tagPageCategories.bestProjects,
        }
      }
      if (tab === tagPageCategories.portfolio) {
        return {
          ...baseFilter,
          ...(isAKI && {
            contexts: ['aki'],
            isContextIgnored: false,
          }),
          // при temp — hsedesigntemp
          ...(checkboxsFilters.temp && {
            contexts: ['hsedesigntemp'],
            isContextIgnored: false,
          }),
          // при ageytomesh — ageytomesh
          ...(isAgeyTomesh && {
            contexts: ['ageytomesh'],
            isContextIgnored: false,
          }),
          ...getCampusGlobalTypes(),
          requestTab: tagPageCategories.portfolio,
        };
      }
      if (tab === tagPageCategories.ftbl) {
        return {
          ...baseFilter,
          isContextIgnored: false,
          contexts: ['ftbl'],
        };
      }
      if (tab === tagPageCategories.competitions) {
        return {
          projectsFilter: Number(sorting) === 1 ? [
            STATUSES.Open,
            STATUSES.Voting
          ] : [sorting]
        }
      }
      else {
        return {
          projectsFilter: sorting
        }
      }
    })
  }, [
    sorting,
    id,
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    moderatedBy,
    createdFrom,
    createdTo,
    extraFilter,
    labContext,
    isHSEDesign,
    isAKI,
    isDeziiign,
    isCreative,
    isSuperPuper,
    creativeTagIds,
    displayTagPageLikeCtx,
    currentCategory,
    baseFilter
  ])

  useEffect(() => {
    if (theTag) {
      setDate(Date.now())
    }
  }, [id, sorting])

  useEffect(() => {
    if (categoryRef && categoryRef.current !== currentCategory) {
      setQueryParams({ sorting: initialSorting }, { replace: true });
      categoryRef.current = currentCategory;
    }
  }, [currentCategory, setQueryParams, initialSorting, categoryRef])

  useEffect(() => {
    dispatch(TagPageSlice.actions.setModerOrExpert(isExpertOrModer || isTagOwnerOrModer || false))
  }, [isExpertOrModer, isTagOwnerOrModer, dispatch, theTag])


  useMemo(() => setCurrentTab(initialTab), [initialTab])

  const requiredFields = useMemo(() =>
    ({ createdFrom, createdTo, teachersOnly, sorting })
    , [createdFrom, sorting, createdTo, teachersOnly])

  useEffect(() => {
    dispatch(fetchTagPageProjectsCount(
      {
        filters: getFiltersForTabs([tagPageCategories.bestProjects, tagPageCategories.portfolio]),
        tagId: id,
      }
    ))

  }, [
    checkboxsFilters.approved,
    checkboxsFilters.notApproved,
    checkboxsFilters.notModerated,
    checkboxsFilters.temp,
    id,
    currentCampusId,
    temp,
    requiredFields,
    createdFrom,
    createdTo,
    moderatedBy
  ])

  useEffect(() => {
    if (!(isTagOwnerOrModer || isExpertOrModer)) {
      setCheckboxsFilters({
        ...initialCheckboxs
      });
    }
  }, [isTagOwnerOrModer, isExpertOrModer, setCheckboxsFilters]);

  const onApprovedHsedesign = useCallback((value: boolean): void => {
    //@ts-ignore
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      approved: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: campusId } : {})
    })
  }, [requiredFields, campusId, currentCampusId]);

  const getCampusIdParam = (currentCampusId: string[]) => {
    if (!currentCampusId ||currentCampusId?.length > 1) {
      return 'main'
    }
    return currentCampusId[0] || 'main'
  }

  const onNotApprovedHsedesign = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      notApproved: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, currentCampusId, campusId]);

  const onNotModerated = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      notModerated: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, campusId, currentCampusId]);

  const onTemp = useCallback((value: boolean): void => {
    setCheckboxsFilters({ 
      ...initialCheckboxs, 
      temp: value, 
      ...requiredFields, 
      ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
  }, [requiredFields, currentCampusId]);

  const onModeratedBy = useCallback((value: string): void => {
    setFilterParam('moderatedBy', value);
  }, []);

  const onCreatedFrom = useCallback((value: string): void => {
    setFilterParam('createdFrom', value);
  }, []);

  const onMonthChange = useCallback((value: string): void => {
    setFilterParam('month', value);
  }, []);

  const onYearChange = useCallback((value: string): void => {
    setFilterParam('year', value);
  }, []);

  const onCreatedTo = useCallback((value: string): void => {
    setFilterParam('createdTo', value);
  }, []);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    const prevData = { approved, notApproved, notModerated, moderatedBy, createdFrom, createdTo, temp, sorting, teachersOnly };
    //@ts-ignore
    setCheckboxsFilters({ ...prevData, sorting: s, ...(currentCampusId?.length ? { campusType: getCampusIdParam(currentCampusId) } : {}) })
    localStorage.setItem('brg_sorting', String(s))
  }, [
    approved, notApproved, notModerated, moderatedBy, createdFrom, createdTo, temp, sorting, teachersOnly, id, currentCampusId
  ]);

  const onMobileSortingClick = useCallback((s: any) => {
    let newSort

    if ([tagPageCategories.competitions]?.includes(currentCategory)) {
      newSort = sorting == 5 ? 1 : 5
    } else {
      newSort = sorting == 1 ? 2 : sorting == 2 ? 26 : sorting == 26 ? 20 : sorting == 20 ? 30 : 1
    }
    // const newSort = ![tagPageCategories.competitions]?.includes(currentCategory) ? sorting == 1 ? 2 : sorting == 2 ? 20 : 1 : 
    // (
    //   sorting == 5 ? 1 : 5
    // )

    localStorage.setItem('brg_sorting', String(newSort))
    setFilterParam('sorting', newSort);
  }, [sorting, setFilterParam, currentCategory]);

  const onProjectsCountSet = useCallback((n: number) => {
    dispatch(TagPageSlice.actions.setCategoryProjectsCount(n))
  }, [dispatch])

  const onChangeStatus = useCallback((newStatus: OptionProps | any) => {
    setQueryParams({ sorting: newStatus?.identifier }, { replace: true })
  }, [setQueryParams])

  // useEffect(() => {
  //   if (displayTagPageLikeCtx) {
  //     setQueryParams({ tab: id })
  //   }
  // } , [id, displayTagPageLikeCtx])

  useEffect(() => {
    if (isProjectPage) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
  }, [isProjectPage, dispatch])

  const disableMobileSortOffset = useMemo(() => {
    if (!is743) {
      if ([tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory) && shouldVisibleAdminTools) return false
      else if ([tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory)) return true;
      return ![tagPageCategories.portfolio, tagPageCategories.bestProjects]?.includes(currentCategory)
    }
    return true
  }, [is743, currentCategory, shouldVisibleAdminTools])

  const mobileSearch = useMemo(() => (
    <MobileSortBar
      directionMobile='row'
      offsetTopMobile={sortOffset}
      offsetBottomMobile={sortOffsetBottom}
      disableOffset={disableMobileSortOffset}
      justifyMobile='flex-end'
      widthMobile={'100%'}
    >
      <MobileFilterSort style={{ marginRight: 0 }} onClick={onMobileSortingClick}>
        <SortIcon />
        {![tagPageCategories.competitions]?.includes(currentCategory) ? (
          t(`sorting_type.${sorting == 1 ? 'latest' : sorting == 2 ? 'rating' : sorting == 26 ? 'popular' : sorting == 20 ? 'relevant' : sorting == 30 ? 'shop' : 'popular'}`)
        ) : (
          t(`sorting_type.${sorting == 5 ? 'ended_competition' : 'current_competition'}`)
        )}
      </MobileFilterSort>
    </MobileSortBar>
  ), [t, currentCategory, onMobileSortingClick, disableMobileSortOffset, shouldVisibleAdminTools, sorting, sortOffset, sortOffsetBottom])


  const sortingMethods = useMemo(() => {
    const shopMethod = showShop ? [30] : [];
    if (AppTester.isDeziiignContext()) {
      return [1, 2, 26, ...shopMethod];
    }
    return [1, 2, 26, 20, ...shopMethod];
  }, [showShop]);

  const searchBar = useMemo(
    () => {
      if (currentCategory === tagPageCategories.experts || isEducationCategory || isOrganizationsCategory) {
        return null;
      }
      if ([tagPageCategories.competitions]?.includes(currentCategory)) {
        return (
          <CompetitionDropdown
            selectedSorting={sorting}
            onSortingChange={onChangeStatus}
            sortingMethods={statusesOptions}
            isDarkTheme={true}
          />
        )
      }

      return (
        <ProjectsSearchBar
          isLoading={false}
          isCategoriesHidden
          sorting={sorting}
          hideRightButtons
          hideLeftBar={true}
          extraFilter={extraFilter}
          onExtraFilterChange={onExtraFilterChange}
          onSortingChange={onSortingChange}
          display={DisplayType.grid}
          isTagPage
          isTagOwnerOrModer={isTagOwnerOrModer}
          // projectCount={projectCount}
          column={!breakpoint}
          sortingMethods={sortingMethods}
          isDarkTheme={isGeo || !(theme as { isDarkText?: boolean }).isDarkText}
        />
      )
    },
    [
      sorting,
      onSortingChange,
      categoryProjectsCount,
      currentCategory,
      extraFilter,
      onExtraFilterChange,
      isEducationCategory,
      isOrganizationsCategory,
      isGeo,
      theme,
    ],
  );

  const filtersContent = useMemo(() => {
    if (isFtbl) return null;
    const tabCondition = (
      ([
        tagPageCategories.portfolio,
        tagPageCategories.bestProjects
      ]
        ?.includes(currentCategory)
        && shouldVisibleAdminTools) ||
      ([
        tagPageCategories.experts,
        tagPageCategories.education,
        tagPageCategories.organizations,
      ])?.includes(currentCategory)
    )

    const offsetBottom = isMedia ? 16 :
      (
        currentCategory === 'portfolio' ||
          currentCategory === 'bestProjects' ||
          currentCategory === 'experts' ||
          currentCategory === 'organizations'
          ? 16 : 0
      )

    if (tabCondition) {
      return (
        <FlexBox
          align='end'
          offsetBottomMobile={offsetBottom}
          justify="space-between"
          direction='row'
          directionMobile={'row'}
        >
          {!displayTagPageLikeCtx && <TagPageSwitcher />}
          {(breakpoint ? mobileSearch : searchBar)}
        </FlexBox>
      )
    } else {
      return (
        <FlexBox
          align='end'
          offsetBottomMobile={offsetBottom}
          justify="space-between"
          direction='row'
          directionMobile={'row'}
        >
          {!displayTagPageLikeCtx && <TagPageSwitcher />}
          {(breakpoint ? mobileSearch : searchBar)}
        </FlexBox>
      )
    }
  }, [
    isTagOwnerOrModer,
    shouldVisibleAdminTools,
    displayTagPageLikeCtx,
    categoryProjectsCount,
    currentCategory,
    breakpoint,
    isMedia,
    is743,
    mobileSearch,
    breakpoint,
    searchBar,
    isFtbl
  ])

  const content = useMemo(() => {
    return (
      <TagContent
        id={id}
        filter={getFiltersForTabs([currentCategory])?.[0]}
        category={currentCategory}
        onProjectsLoaded={(p) => setProjects(p)}
        projects={projects}
        setProjectCount={onProjectsCountSet}
        date={date}
        isModer={canVisibleBriefs}
        isInfinityNeed={true}
        currentTab={serialzeTab}
        externalPageParam
        isTagCategory={isTagCategory}
        tagIsLoading={tagIsLoading}
      />
    )
  }, [
    id,
    currentCategory,
    canVisibleBriefs,
    date,
    serialzeTab,
    onProjectsCountSet,
    getFiltersForTabs,
    projects
  ])

  const tagAdminSearchBar = useMemo(() => {
    if (!shouldVisibleAdminTools) return null;
    return (
      //@ts-ignore
      ((isTagOwnerOrModer || isExpertOrModer) ? (
        <FlexBox
          direction="column"
          directionMobile="column"
          offsetTop={24}
          gy={24}
          gyMobile={0.01}
          width="100%"
        >
          <TagAdminProjectsSearchBar
            approved={checkboxsFilters.approved}
            notApproved={checkboxsFilters.notApproved}
            notModerated={checkboxsFilters.notModerated}
            filter={baseFilter?.globalTypes}
            temp={checkboxsFilters.temp}
            moderatedBy={moderatedBy}
            tagId={id}
            // createdFrom={createdFrom}
            // createdTo={createdTo}
            onApprovedHsedesign={onApprovedHsedesign}
            onNotApprovedHsedesign={onNotApprovedHsedesign}
            onNotModerated={onNotModerated}
            onTemp={onTemp}
            onModeratedBy={onModeratedBy}
            onCreatedFrom={onCreatedFrom}
            onMonthChange={onMonthChange}
            onYearChange={onYearChange}
            onCreatedTo={onCreatedTo}
            extraFilter={extraFilter}
            onExtraFilterChange={onExtraFilterChange}
            filterContent={/*!breakpoint && */(breakpoint ? (!isMedia && mobileSearch) : searchBar)}
          />
        </FlexBox>
      ) : (
        <ProjectsSearchBarFlex gx={24} style={{ display: isMobile ? 'none' : 'flex' }}>
          <FInter.SmallTextMagic
            style={{ fontSize: '15px', lineHeight: '20px', fontWeight: '700', whiteSpace: 'nowrap' }}
            align={'center'}
            color={theme.allTagsBtn.colorHover}>
            {t('filter.projects') + '' + `(${categoryProjectsCount || 0})`}
          </FInter.SmallTextMagic>
        </ProjectsSearchBarFlex>
      ))
    )
  },
    [profile,
      theTag,
      onApprovedHsedesign,
      onNotApprovedHsedesign,
      onNotModerated,
      onModeratedBy,
      onCreatedFrom,
      onCreatedTo,
      checkboxsFilters,
      moderatedBy,
      breakpoint,
      id,
      categoryProjectsCount,
      isExpertOrModer,
      isTagOwnerOrModer
    ],
  );

  if (id === AGEYTOMESH_TAG_ID) {
    window.location.replace('https://ageytomesh.com');
  }

  if (tagIsLoading) {
    return <TagViewLayout theme={theme} bgColor={bgColor} isLoading={true} />
  }

  if (isFrShowcasePage) {
    return <CampusExpert 
      tagAdminFiltersContent={tagAdminSearchBar}
      content={content}
    />
  }

    // Обработка ошибок
  if (tagRequestErrored && !isFrShowcasePage) {
    return <NotFoundPage />
  }

  const isPersonalized = !!(theTag as any)?.isPersonalized;

  return (
    <>
      <MetaTags
        title={String(bTag.title(theTag))}
        canonicalInfo={(theTag as any)?.canonicalInfo}
      />
      <TagViewLayout
        key={id}
        //todo разобраться с темами
        theme={theme}
        bgColor={bgColor}
        isLoading={tagIsLoading}
        isTagsLoading={isTagsLoading}
        tagsContent={tagsContent}
        title={String(bTag.title(theTag))}
        filtersContent={filtersContent}
        tagAdminFiltersContent={tagAdminSearchBar}
        //@ts-ignore
        openLikeCtx={!isPersonalized && displayTagPageLikeCtx}
        description={tagDescription}
        tagCard={card}
        tagTabsContent={TagTabs}
        projectsContent={content}
        isTagOwnerOrModer={isTagOwnerOrModer || isTagExpert || isTagExpertByPolicy}
        id={id}
        headerContent={isPersonalized ? (
          <PersonalizedTag
            tag={theTag}
            isLoading={tagIsLoading}
            theme={theme1}
          />
        ) : undefined}
      />
    </>
  );
};
